<template>
  <div class="t-scrollmore">
    <div v-if="!isEmpty">
      <slot></slot>
    </div>
    <t-empty v-else :text="emptyText"></t-empty>
    <t-more v-if='tipText' :icon="icon" :text="tipText"></t-more>
  </div>
</template>
<script>
    /**
     * @param tip [String] 最后一页加载完提示文字，默认[没有更多]
     * @param loadTip [String] 触发加载中提示文字，默认[加载中...]
     * @param empty [Boolean] 是不是空的
     * @describe  默认加载第一页也可以调用onPaging方法，只需将currentPage默认为0,加载完成之后需要触发loaded方法并且传递是否最后一页和当前页参数
     * 默认不触发分页事件，需要触发一次loaded才能开启事件(默认isLock为true)即需要加载第一页后触发，记：分页组件是用来加载分页的，不能由内部触发第一页
     *
     * @example  <t-scrollmore @load="onPaging" ref="scrollmore" empty=""> 分页列表 </t-scrollmore>
     *
     onPaging: function () {
      this.form.currentPage++;
      this.getJSON('/api/getlist', this.form, (data) => {
        if (!data.errcode) {
          	this.list = this.list.concat(data.data);
	        this.form.isLastPage = data.data.length < this.form.pageSize;
	        this.form.isEmpty = this.list.length === 0;
	        this.$refs.scrollmore.$emit('loaded', this.form);
        }
      });
    },
     */
    import tMore from './more.vue';
    import tEmpty from './custom/empty.vue';

    export default {
        name: 'tScrollmore',
        props: {
            tip: { type: String, default: '没有更多' },
            loadTip: { type: String, default: '加载中...' },
            empty: { type: Boolean, default: false },
        },
        data() {
            return {
                isLock: true,
                tipText: '',
                icon: false,
                isEmpty: this.empty,
                emptyText: ''
            };
        },
        watch: {
            empty(val) {
                this.isEmpty = val;
            },
        },
        created: function () {
            // 加载完调用(触发监听)this.$refs.scrollmore.$emit('loaded', form);
            this.$on('loaded', function (form) {
                console.log(form);
                this.icon = false;
                this.isLock = form.isLastPage;
                this.tipText = (form.isLastPage && form.currentPage !== 1) ? this.tip : '';
                this.isEmpty = form.isEmpty;
                this.emptyText = form.emptyText || '暂无数据';
            });
        },
        components: { tMore, tEmpty },
        mounted: function () {
            window.addEventListener('scroll', this.paging);
        },
        beforeDestroy: function () {
            window.removeEventListener('scroll', this.paging);
        },
        methods: {
            paging: function () {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const windowHeight = window.innerHeight;
                const documentHeight = document.body.clientHeight;
                this.$emit('scroll', scrollTop, windowHeight, documentHeight);
                // 判断滚动到底部
                if (scrollTop && scrollTop + windowHeight >= documentHeight - 50 && !this.isLock) {
                    this.icon = true;
                    this.tipText = this.loadTip;
                    this.isLock = true;
                    // const isLastPage = (this.form.pageSize * this.form.currentPage) >= this.form.total;
                    this.$emit('load');
                }
            },
        },
    };

</script>
<style scoped lang="scss">
  .t-scrollmore {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/scrollmore.vue